<template>
  <div>
    <span class="font-bold text-lg">Videolar ro'yxati</span>

    <!-- Desktop Table View (hidden on mobile) -->
    <div
      class="hidden md:block max-h-[calc(100vh-250px)] overflow-y-auto overflow-x-auto"
    >
      <table class="min-w-full w-full border-collapse">
        <thead>
          <tr>
            <th class="sticky top-0 bg-white z-10 px-4 py-2 border-b">№</th>
            <th class="sticky top-0 bg-white z-10 px-4 py-2 border-b text-left">
              Video
            </th>
            <th class="sticky top-0 bg-white z-10 px-4 py-2 border-b">
              Holati
            </th>
            <th class="sticky top-0 bg-white z-10 px-4 py-2 border-b">
              Sanasi
            </th>
            <!--            <th class="sticky top-0 bg-white z-10 px-4 py-2 border-b">-->
            <!--              Просмотр-->
            <!--            </th>-->
            <!--            <th class="sticky top-0 bg-white z-10 px-4 py-2 border-b">-->
            <!--              Комментарий-->
            <!--            </th>-->
            <!--            <th class="sticky top-0 bg-white z-10 px-4 py-2 border-b">-->
            <!--              Нравится-->
            <!--            </th>-->
            <th class="sticky top-0 bg-white z-10 px-4 py-2 border-b">Narxi</th>
            <!--            <th class="sticky top-0 bg-white z-10 px-4 py-2 border-b">-->
            <!--              Покупки-->
            <!--            </th>-->
            <th
              class="sticky top-0 bg-white z-10 px-4 py-2 border-b"
              v-if="checkPermission([110])"
            >
              Amallar
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in vidioData" :key="index">
            <td class="px-4 py-2 border-b border-gray-200 text-sm text-center">
              {{ index + 1 }}
            </td>
            <td
              class="px-4 py-2 border-b border-gray-200 text-sm cursor-pointer"
            >
              <div class="flex items-center" @click="playVidio(item)">
                <div class="relative mr-3 flex-shrink-0">
                  <img
                    :src="item.wrapperUrl"
                    class="w-28 h-20 object-cover rounded-md"
                    alt="Wrapper"
                  />
                  <div
                    class="absolute bottom-1 right-1 bg-black bg-opacity-70 text-white text-xs px-1 py-0.5 rounded"
                  >
                    {{ item.vidioTime }}
                  </div>
                </div>
                <div class="relative group">
                  <p class="text-sm truncate max-w-xs">{{ item.title }}</p>
                  <div
                    class="hidden group-hover:block absolute z-10 bg-gray-800 text-white p-2 rounded shadow-lg text-xs w-60 mt-1"
                  >
                    {{ item.title }}
                  </div>
                </div>
              </div>
            </td>
            <td class="px-4 py-2 border-b border-gray-200 text-sm text-center">
              <span v-if="item.status === 'CREATED'"> Yuklangan </span>
              <div
                v-if="item.status === 'REJECTED'"
                class="flex items-center justify-center gap-0.5"
              >
                <span class="font-bold" style="color: #ff2d55">
                  Rad etilgan
                </span>
                <el-tooltip :content="item.rejectReason" placement="top">
                  <img
                    src="@/assets/image/reject_icon.png"
                    alt="reject"
                    class="cursor-pointer"
                  />
                </el-tooltip>
              </div>
              <span
                v-if="item.status === 'CONFIRMED'"
                class="text-green-500 font-bold"
              >
                Tasdiqlangan
              </span>
            </td>
            <td class="px-4 py-2 border-b border-gray-200 text-sm text-center">
              {{ item.date }}
            </td>
            <!--            <td class="px-4 py-2 border-b border-gray-200 text-sm text-center">-->
            <!--              {{ item.view }}-->
            <!--            </td>-->
            <!--            <td class="px-4 py-2 border-b border-gray-200 text-sm text-center">-->
            <!--              {{ item.comment }}-->
            <!--            </td>-->
            <!--            <td class="px-4 py-2 border-b border-gray-200 text-sm text-center">-->
            <!--              {{ item.like }}-->
            <!--            </td>-->
            <!--            </td>-->

            <td class="px-4 py-2 border-b border-gray-200 text-sm text-center">
              {{ item.price }} so'm
            </td>
            <!--            <td class="px-4 py-2 border-b border-gray-200 text-sm text-center">-->
            <!--              {{ item.purchases }}-->
            <!--            </td>-->
            <td
              class="px-4 py-2 border-b border-gray-200 text-sm text-center"
              v-if="checkPermission([110])"
            >
              <!--              <span-->
              <!--                class="text-green-600 bg-[#afffaf] rounded-[14px] px-[8px] py-[2px] cursor-pointer"-->
              <!--                @click="confirmApproval(item)"-->
              <!--                >Tasdiqlash</span-->
              <!--              >-->
              <div class="flex gap-1">
                <button
                  class="py-[5px] px-[10px] bg-green-500 text-white rounded-[5px] border-none"
                  @click="confirmApproval(item)"
                  v-if="item.status === 'CREATED'"
                >
                  <i class="fa-solid fa-check"></i>
                </button>
                <button
                  class="py-[5px] px-[10px] bg-red-500 text-white rounded-[5px] border-none"
                  @click="canselApproval(item)"
                  v-if="item.status === 'CREATED'"
                >
                  <i class="fa-solid fa-xmark"></i>
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div
      v-if="isSubmitting"
      class="fixed inset-0 bg-black bg-opacity-30 z-50 flex items-center justify-center"
    >
      <div class="flex flex-col items-center">
        <svg
          class="animate-spin h-8 w-8 text-indigo-600 mb-2"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
        >
          <circle
            class="opacity-25"
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            stroke-width="4"
          ></circle>
          <path
            class="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 018-8v8H4z"
          ></path>
        </svg>
        <p class="text-blue-500 text-sm">Yuklanmoqda...</p>
      </div>
    </div>
    <div class="mt-[30px]">
      <button
        class="bg-purple-600 hover:bg-purple-700 text-white px-4 py-2 rounded-full text-sm flex items-center"
        @click="uploadVidioForm"
      >
        <img src="@/assets/image/solar_stream-bold.png" alt="" class="mr-2" />
        <span>Yuklash</span>
      </button>
    </div>
  </div>
</template>

<script>
import http from "@/http";
import { ElMessageBox, ElMessage } from "element-plus";

export default {
  data() {
    return {
      vidioData: [
        // {
        //   wrapperUrl: "/img/test.c92764e2.jpg",
        //   status: "CONFIRMED",
        //   date: "01.05.2025",
        //   view: 0,
        //   comment: 0,
        //   like: 0,
        //   id: "3935ea79-2181-4191-b3bd-7705ff533d3d",
        //   price: 129000,
        //   purchases: 23,
        //   title:
        //     "The art of storytelling, weaving tales that captivate and inspire audiences across generations",
        //   vidioTime: "12:00",
        //   rejectReason: "Noto'g'ri kontent",
        // },
      ],
      isSubmitting: false,
      userInfo: {},
    };
  },
  mounted() {
    this.getExtraData();
  },
  methods: {
    playVidio(item) {
      this.$router.push(`/main/watch-video-admin?videoId=${item.id}`);
    },
    canselApproval(item) {
      ElMessageBox.prompt("Bekor qilish sababini kiriting:", "Bekor qilish", {
        confirmButtonText: "Yuborish",
        cancelButtonText: "Bekor qilish",
        inputPlaceholder: "Masalan: noto‘g‘ri yuklangan video",
        inputValidator: (value) => {
          if (!value) {
            return "Sababni kiritish majburiy";
          }
          return true;
        },
        center: true,
      })
        .then(async ({ value }) => {
          try {
            let response = await http.post(
              `/video/video-action?videoId=${item.id}&type=reject`,
              {
                rejectReason: value,
              }
            );
            if (response) {
              ElMessage({
                type: "success",
                message: "Bekor qilindi!",
              });
              window.location.reload();
            }
          } catch (error) {
            console.error("Xatolik:", error);
          }
        })
        .catch(() => {
          ElMessage({
            type: "info",
            message: "Amal bekor qilindi",
          });
        });
    },
    confirmApproval(item) {
      ElMessageBox.confirm("Bu videoni tasdiqlashni hohlaysizmi ?", {
        confirmButtonText: "Ha",
        cancelButtonText: "Yo‘q",
        center: true,
        draggable: false,
      })
        .then(async () => {
          try {
            if (this.isSubmitting) return;
            this.isSubmitting = true;
            let response = await http.post(
              `/video/video-action?videoId=${item.id}&type=accept`
            );
            if (response) {
              ElMessage({
                type: "success",
                message: "Tasdiqlandi!",
              });
              window.location.reload();
            }
          } catch (error) {
            console.error("failed", error);
          } finally {
            this.isSubmitting = false;
          }
        })
        .catch(() => {
          ElMessage({
            type: "info",
            message: "Bekor qilindi",
          });
        });
    },
    uploadVidioForm() {
      this.$router.push("/main/video-upload");
    },
    async getVidioList() {
      if (this.isSubmitting) return;
      const userInfo = this.userInfo;
      this.isSubmitting = true;
      try {
        let url = "/video/all-videos";
        if (userInfo && userInfo.orgId !== null) {
          url = `/video/all-videos?orgId=${userInfo.orgId}`;
        }
        let response = await http.post(url, {});
        this.vidioData = response.data.data.content;
      } catch (error) {
        console.error("failed", error);
      } finally {
        this.isSubmitting = false;
      }
    },
    checkPermission(allowedPermissions) {
      const userInfo = JSON.parse(localStorage.getItem("user_info"));
      const userPermissions = userInfo ? userInfo.permissionId : [];
      return allowedPermissions.some((permission) =>
        userPermissions.includes(permission)
      );
    },
    async getExtraData() {
      try {
        let response = await http.get("/auth/extra-data");
        localStorage.setItem("user_info", JSON.stringify(response.data));
        this.userInfo = response.data;
        await this.getVidioList();
      } catch (e) {
        console.log(e.message);
      }
    },
  },
};
</script>
